<script>
/* COMPOSANTS */
import MultiSelect from 'primevue/multiselect';
import AkCalendar from '@components/v2/input/AkCalendar.vue';
import AkAutocomplete from '@components/v2/input/AkAutocomplete.vue';
import AkInputText from '@components/v2/input/AkInputText.vue';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';

/* MIXINS */
import sidebarMixin from '@mixins/sidebarMixin';
import utilsMixin from '@mixins/utilsMixin';
import maintenanceStatusConst from '@mixins/const/maintenanceStatusConst';
import maintenanceTagConst from '@mixins/const/maintenanceTagConst';
import permissionsMixin from '@mixins/permissionsMixin';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import ownerAutocompleteMixin from '@mixins/autocomplete/ownerAutocompleteMixin';
import mandatAutocompleteMixin from '@mixins/autocomplete/mandatAutocompleteMixin';
import companyMixin from '@mixins/companyMixin';

export default {
  components: {
    AkInputText,
    AkAutocomplete,
    AkCalendar,
    MultiSelect,
    AkButtonFooterSidebarFilter,
  },
  mixins: [
    utilsMixin,
    sidebarMixin,
    permissionsMixin,
    maintenanceStatusConst,
    maintenanceTagConst,
    accommodationAutocompleteMixin,
    ownerAutocompleteMixin,
    mandatAutocompleteMixin,
    companyMixin,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      statuses: [],
    };
  },
  mounted() {
    this.statuses = this.isOwner()
      ? this.maintenanceStatusConstForOwnerFilter()
      : this.maintenanceStatusConstForFilter();
  },
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      if (this.$refs.accommodationAutocomplete) this.$refs.accommodationAutocomplete.reset();
      if (this.$refs.ownerAutocomplete) this.$refs.ownerAutocomplete.reset();
      if (this.$refs.mandatAutocomplete) this.$refs.mandatAutocomplete.reset();
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-if="isGas() && companies && !currentValue.isFromAccommodationPage"
      v-model="currentValue.companyIds"
      :loading="loadingCompanies"
      :options="companies"
      :placeholder="$t('employee.company')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="name"
      option-value="id"
      @change="itemSelect" />

    <AkAutocomplete
      v-if="!isOwner() && !currentValue.isFromAccommodationPage"
      ref="ownerAutocomplete"
      v-model="currentValue.ownerId"
      :init-method="autocompleteOwnerById"
      :placeholder="$t('owner.ownerDisplay')"
      :search-label="autocompleteOwnerQuery"
      :search-method="autocompleteOwner"
      inline
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />

    <AkAutocomplete
      v-if="!currentValue.isFromAccommodationPage"
      ref="accommodationAutocomplete"
      v-model="currentValue.accommodationId"
      :init-method="autocompleteAccommodationById"
      :placeholder="$t('accommodation.short')"
      :search-label="autocompleteAccommodationQuery"
      :search-method="autocompleteAccommodation"
      inline
      :minLengthToLaunchSearch="3"
      option-label="display"
      option-value="id"
      @item-select="itemSelect" />

    <AkAutocomplete
      v-if="!currentValue.isFromAccommodationPage"
      ref="mandatAutocomplete"
      v-model="currentValue.mandatId"
      :init-method="autocompleteMandatById"
      :label="$t('mandat.details')"
      :search-method="autocompleteMandat"
      inline
      option-label="num"
      option-value="id"
      @item-select="itemSelect" />

    <AkInputText
      v-model="currentValue.problem"
      :placeholder="$t('maintenance.problem')"
      inline
      @valueChange="itemSelect" />

    <MultiSelect
      v-model="currentValue.tags"
      :options="maintenanceTagConst"
      :placeholder="$t('maintenance.tag')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="label"
      option-value="value"
      @change="itemSelect" />

    <AkCalendar
      v-model="currentValue.dateMaintenance"
      :placeholder="$t('maintenance.date_maintenance')"
      date-format="dd/mm/yy"
      selection="range"
      inline
      @valueChange="itemSelect" />

    <MultiSelect
      v-model="currentValue.statuses"
      :options="statuses"
      :placeholder="$t('maintenance.status')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      inline
      option-label="label"
      option-value="value"
      @change="itemSelect" />

    <AkButtonFooterSidebarFilter :validateLabel="$t('search.search')" @action="search" @reset="reset" />
  </form>
</template>
